import Header from "./components/Header/Header";
import Otctrading from "./components/Home/Otctrading/Otctrading";

import React from "react";

function App() {
  return (
    <React.Fragment>
      <Header title="OTC Trading" />
      <Otctrading />
    </React.Fragment>
  );
}

export default App;
